import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initializeMonitoring } from "./shared/utils/monitoring";
import { logPerformanceMetrics } from "./shared/utils/performanceMonitoring";

// Initialize frontend monitoring
initializeMonitoring();

// Track Web Vitals performance metrics
if (import.meta.env.PROD) {
  logPerformanceMetrics();
}

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        
        // Register background sync for offline submissions
        if ('sync' in (window as any).ServiceWorkerRegistration.prototype) {
          return navigator.serviceWorker.ready.then((reg: any) => {
            return reg.sync.register('offline-submissions');
          });
        }
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Could show update notification here
              }
            });
          }
        });
      })
      .then(() => {
      })
      .catch((error) => {
        console.error('❌ SW: Service Worker registration failed:', error);
      });
  });
  
  // Listen for messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SYNC_OFFLINE_QUEUE') {
      // Import and process offline queue when SW requests it
      import('./utils/offlineQueue').then(({ default: offlineQueue }) => {
        offlineQueue.processQueue();
      });
    }
  });
  
  // Cross-platform fallback for iOS Safari (no background sync support)
  window.addEventListener('online', () => {
    // Fallback processing for platforms without background sync
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'PROCESS_QUEUE_FALLBACK'
      });
    }
  });
  
  // Process queue on app visibility change (return from background)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && navigator.onLine) {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'PROCESS_QUEUE_FALLBACK'
        });
      }
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
